var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Polaris-Layout"
  }, [_vm._l((_vm.$slots), function(slot, name) {
    return (_vm.sectioned) ? [_c('polaris-layout-section', [_vm._t(name)], 2)] : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.$slots), function(slot, name) {
    return (!_vm.sectioned) ? [_vm._t(name)] : _vm._e()
  })], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0849e86e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0849e86e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisLayout.vue
// module id = 193
// module chunks = 0